export default "__VITE_ASSET__21fdb30b__"